import React from 'react';

import classNames from 'classnames';

function BackDrop({ isShow, toggle }) {
  return (
    <div
      role="presentation"
      className={classNames('sidebar-backdrop', { 'is-show': isShow })}
      onClick={toggle}
      onKeyDown={toggle}
      onKeyUp={toggle}
    />
  );
}

export default BackDrop;
